// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2b99aa78]:export{primaryColor:#008ab4;secondaryColor:#c2287d;accentColor:#c41230}", ""]);
// Exports
module.exports = exports;
